import { Component } from '@angular/core';
import { Subject } from "rxjs";

type NotificationType = 'info' | 'success' | 'error' | 'warn';

export class NotificationData {
  constructor(
    public type: NotificationType,
    public title: string,
    public message: string,
    public timeoutSec?: number,
  ) { }
}

const showNotificationSubject = new Subject<NotificationData>();

export function showNotification(type: NotificationType, title: string, message: string, timeoutSec?: number) {
  showNotificationSubject.next(new NotificationData(type, title, message, timeoutSec));
}

@Component({
  selector: 'app-notifications',
  templateUrl: './app-notifications.component.html',
  styleUrls: ['./app-notifications.component.scss']
})
export class AppNotifications {
  notifications: NotificationData[] = [];

  constructor() {
    showNotificationSubject.subscribe(async notification => {
      this.notifications.push(notification);
      if (notification.timeoutSec !== undefined) {
        setTimeout(() => this.close(notification), notification.timeoutSec * 1000);
      }
    });
  }

  getIcon(type: NotificationType) {
    switch (type) {
      case "info":
        return { 'bi-info-circle': true };;
      case "success":
        return { 'bi-check-circle': true };
      default:
        return { 'bi-exclamation-triangle': true }
    }
  }

  close(notification: NotificationData) {
    this.notifications = this.notifications.filter(n => n !== notification);
  }

  getColor(type: NotificationType) {
    switch (type) {
      case "info":
        return "blue";
      case "success":
        return "green";
      case "error":
        return "red";
      case "warn":
        return "yellow";
    }
  }
}